import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumPublicIDs } from "@/components/Logo/Product/ProductLogoMediumPublicIDs";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";
export const Route = createFileRoute("/_staff/public-ids/_list")({
  component: PublicIdsLayout,
});

function PublicIdsLayout() {
  const { t } = useTranslation(defaultNS);
  useDocumentTitle(t("pages.publicIds.title"));

  const tabs = [
    {
      to: "/public-ids",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
      disabled: true, // 未実装のためリダイレクト
    },
    {
      to: "/public-ids/registry",
      children: t("common.list.publicIds"),
    },
    {
      to: "/public-ids/members",
      children: t("common.list.people"),
      disabled: true, // 未実装のためリダイレクト
    },
    {
      to: "/public-ids/alerts",
      children: t("common.list.alerts"),
      disabled: true, // 未実装のためリダイレクト
    },
    {
      to: "/public-ids/operation-activity",
      children: t("common.list.operationActivity"),
      disabled: true, // 未実装のためリダイレクト
    },
    {
      to: "/public-ids/rules-and-policies",
      children: t("common.list.ruleAndPolicy"),
      disabled: true, // 未実装のためリダイレクト
    },
    {
      to: "/public-ids/settings",
      children: t("common.list.settings"),
      disabled: true, // 未実装のためリダイレクト
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={ProductLogoMediumPublicIDs}
        name={t("pages.publicIds.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
